export default {
  name: 'release-management',
  translationKey: 'release-management-module',
  routePrefix: 'release-management',
  routeNamePrefix: 'admin.release-management',
  directRoutesAvailable: false,
}
